export default __webpack_public_path__ + "static/media/2019-mantenimeinto-SEIEM-App.3ae35b4d.png";